<template>
  <div >
    <div>
    <Sidebar />
    <div class="contact-box-wrapper">
    <div class="content-box" v-if="selectedPath && !lessonId">
        <div class="content-wrapper" >
          <h2 class="cont-head">{{getSelectedPath.title}}</h2>
          <div v-if="getSelectedPath" class="rich-txt w-richtext" v-html="getSelectedPath.info"></div>
        </div>
      </div>
    <router-view />
    </div>
    </div>

  </div>
</template>

<style>
.content-wrapper, .file-box {
  vertical-align: top;
}
.over-flow {
  text-overflow: ellipsis;
  max-width: 50px;
}
</style>

<script>
  import {mapActions, mapGetters} from "vuex";
import Sidebar from "./Sidebar";
// import loader from "../components/loader";

export default {
  name: "path_content",
  data(){
    return {
      selectedPath:null
    }
  },

  computed: {
...mapGetters(['getSelectedPath']),
    lessonId(){
      return this.$route.params.lessonID;
    }
  },
  async mounted() {
    await this.fetchSelectedPath(this.$route.params.id);
    if (this.$route.params.lessonID){
      await this.setChapter(this.$route.params.chapterID)
      await this.setLesson(this.$route.params.lessonID);
      await this.fetchComments;
    }

  },
  beforeRouteUpdate (to, from, next) {
    this.setChapter(to.params.chapterID);
    this.setLesson(to.params.lessonID);
    next();
  },
  methods: {
    async setLesson(chapterClassId) {
      this.selectedClass = this.$store.getters.getLessonById(chapterClassId);
      if (!this.selectedClass) {
        this.$store
                .dispatch("fetchSelectedLesson", chapterClassId)
                .then(() => {
                  this.selectedClass = this.$store.getters.getLessonById(
                          chapterClassId
                  );
                })
                .catch(err => {
                  console.log(err);
                });
      } else {
        this.$store.commit(
                "setLesson",
                this.selectedClass
        );
      }
    },
    async setChapter(chapterId) {
      this.selectedChapter = this.$store.getters.getChapterById(chapterId);
      if (!this.selectedChapter) {
        this.$store
                .dispatch("fetchSelectedChapter", chapterId)
                .then(() => {
                  this.selectedClass = this.$store.getters.getChapterById(
                          chapterId
                  );
                })
                .catch(err => {
                  console.log(err);
                });
      } else {
        await this.$store.commit(
                "setChapter",
                this.selectedChapter
        );
      }
      await this.fetchComments();
    },
    ...mapActions([
      "fetchSelectedPath",
      "setChapterAction",
      "fetchSelectedLesson",
      "fetchComments"
    ])
  },

  watch:{
    getSelectedPath(){
      this.selectedPath = this.getSelectedPath;
    }
  },
  components: { Sidebar }
};
</script>
